import React from "react";
import { Button, Dropdown, Menu } from "antd";
import { EditOutlined } from "@ant-design/icons";
import RejectIcon from "../../assets/images/Reject.svg";
import AcceptIcon from "../../assets/images/AcceptIcon.svg";

const modifyItemsButtonStyle = {
  height: "28px",
  fontSize: "12px",
  borderRadius: "6px",
  backgroundColor: "#2F3856",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
};

const ActionButtons = ({ selectedOrder, loading, onAccept, onReject, onMarkAsReady, onComplete, onModifyItems, allowModification, rejectReasons }) => {
  const rejectMenu = (
    <Menu onClick={({ key }) => onReject(key)}>
      {rejectReasons.map((reason) => (
        <Menu.Item key={reason} style={{ fontSize: "12px" }}>
          {reason.replace(/_/g, " ").toUpperCase()}
        </Menu.Item>
      ))}
    </Menu>
  );

  if (!selectedOrder) return null;

  switch (selectedOrder.status) {
    case "NEW":
      return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
          <Dropdown overlay={rejectMenu} trigger={["click"]}>
            <Button
              style={{
                height: "28px",
                fontSize: "12px",
                borderRadius: "6px",
                border: "1px solid #dc2626",
                color: "#dc2626",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
              }}
              disabled={loading}
            >
              <img src={RejectIcon} style={{ height: "16px" }} alt="Reject" />
              Reject
            </Button>
          </Dropdown>
          <Button
            onClick={onAccept}
            style={{
              height: "28px",
              fontSize: "12px",
              borderRadius: "6px",
              backgroundColor: "#2F3856",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
            }}
            disabled={loading}
          >
            <img src={AcceptIcon} style={{ height: "16px" }} alt="Accept" />
            Accept
          </Button>
        </div>
      );
    case "AK": {
      const markAsReadyButton = (
        <Button
          onClick={onMarkAsReady}
          style={{
            height: "28px",
            fontSize: "12px",
            borderRadius: "6px",
            backgroundColor: "#E99013",
            color: "#fff",
          }}
          disabled={loading}
        >
          Mark as Ready
        </Button>
      );
      if (!allowModification) return markAsReadyButton;
      return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
          {markAsReadyButton}
          <Button onClick={onModifyItems} style={modifyItemsButtonStyle} disabled={loading}>
            <EditOutlined />
            Modify Items
          </Button>
        </div>
      );
    }
    case "FR": {
      const dispatchButton = (
        <Button
          onClick={onComplete}
          style={{
            height: "28px",
            fontSize: "12px",
            borderRadius: "6px",
            backgroundColor: "#008000",
            color: "#fff",
          }}
          disabled={loading}
        >
          Dispatch
        </Button>
      );
      if (!allowModification) return dispatchButton;
      return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
          {dispatchButton}
          <Button onClick={onModifyItems} style={modifyItemsButtonStyle} disabled={loading}>
            <EditOutlined />
            Modify Items
          </Button>
        </div>
      );
    }
    case "DI":
      return null;
    default:
      return null;
  }
};

export default ActionButtons;